@if (isDecoding()) {
<!-- Skeleton while decoding audio -->
<div
  class="flex-1 rounded-full animate-pulse bg-[#E07A5F]/[0.08] dark:bg-[#E07A5F]/[0.12]"
  [style.height.px]="heightPx()"
></div>
} @else {
<div
  role="button"
  tabindex="0"
  class="flex items-end gap-[2px] flex-1 overflow-hidden touch-none"
  [class.cursor-pointer]="hasRealWaveform()"
  [style.height.px]="heightPx()"
  (click)="onWaveformClick($event)"
  (touchend)="onWaveformClick($event)"
  (keydown.enter)="onWaveformClick($event)"
  (keydown.space)="onWaveformClick($event)"
>
  @for (bar of bars(); track bar.id) {
  <div
    class="w-[3px] rounded-full shrink-0 transition-colors duration-150"
    [class]="hasRealWaveform()
      ? (bar.played ? 'bg-primary' : 'bg-primary/20 dark:bg-white/15')
      : 'bg-primary/70'"
    [class.waveform-bar--pulse]="isAnimating() && bar.played && hasRealWaveform()"
    [class.waveform-bar--wave]="isAnimating() && !hasRealWaveform()"
    [style.height]="bar.height"
    [style.animation-delay]="bar.delay"
  ></div>
  }
</div>
}
